/** Activity labels built only in the app (tests/fixtures/activity-labels/ui.json). English equals the fixture exactly. */
export default {
  "ui.working_on_screen": "Working on your screen",
  "ui.filled_field": "Filled {field}",
  "ui.check_field": "Check {field}",
  "ui.app_step": "{app}, {action|lower}",
  "ui.choosing_menu_command": "Choosing a menu command",
  "ui.replacing_text": "Replacing text",
  "ui.typing": "Typing",
  "ui.a_key": "a key",
  "ui.waking_up": "waking up...",
} as const;
